import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Card from "@material-ui/core/Card";
import { ListView, PairView } from "./PairView";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { useOnEnter } from "../../../hooks/DialogHooks";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogWindow = ({ changes, onCancel, onOk }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleClose = () => {
    onCancel();
  };

  const handleApplyChanges = () => {
    onOk();
  };

  useOnEnter(handleApplyChanges);

  return (
    <Dialog
      maxWidth={"lg"}
      open={true}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {t("Preview changes")}
          </Typography>
          <Button color="inherit" onClick={handleApplyChanges}>
            {t("Apply changes")}
          </Button>
        </Toolbar>
      </AppBar>
      {changes.Modified && changes.Modified.length > 0 && (
        <>
          <Card>
            <CardHeader title={t("Modified events")} />
            <CardContent>
              <ListView list={changes.Modified} />
            </CardContent>
          </Card>
        </>
      )}
      {changes.Unpaired && changes.Unpaired.length > 0 && (
        <>
          <Card>
            <CardHeader title={t("Destroyed pairs")} />
            <CardContent>
              <PairView list={changes.Unpaired} />
            </CardContent>
          </Card>
          <Divider />
        </>
      )}
      {changes.Paired && changes.Paired.length > 0 && (
        <>
          <Card>
            <CardHeader title={t("New pairs")} />
            <CardContent>
              <PairView list={changes.Paired} />
            </CardContent>
          </Card>
          <Divider />
        </>
      )}
    </Dialog>
  );
};

export default DialogWindow;
